if (!customElements.get('sidecart-v2')) {

  // EU weight-based rate table: [maxWeightGrams, rateInPence]
  const EU_RATES = [
    [20000,  2914],
    [41000,  4404],
    [80000,  5912],
    [120000, 7416],
    [140000, 9212],
    [180000, 11008],
    [220000, 12804],
    [260000, 14600],
    [300000, 16396],
    [340000, 18192],
    [380000, 19988],
    [420000, 21784],
    [460000, 23580],
    [Infinity, 25376],
  ];

  // US weight-based rate table: [maxWeightGrams, rateInCents]
  const US_RATES = [
    [500,   2420],
    [1000,  2647],
    [1500,  2877],
    [2000,  3105],
    [2500,  3334],
    [3000,  3465],
    [3500,  3596],
    [4000,  3727],
    [4500,  3858],
    [5000,  3989],
    [5500,  4154],
    [6000,  4319],
    [6500,  4484],
    [7000,  4649],
    [7500,  4814],
    [8000,  4979],
    [8500,  5144],
    [9000,  5309],
    [9500,  5474],
    [10000, 5640],
    [10500, 5763],
    [11000, 5885],
    [11500, 6007],
    [12000, 6130],
    [12500, 6252],
    [13000, 6375],
    [13500, 6499],
    [14000, 6621],
    [14500, 6744],
    [15000, 6866],
    [16000, 7111],
    [17000, 7358],
    [18000, 7602],
    [19000, 7847],
    [20000, 8094],
    [21000, 8317],
    [22000, 8521],
    [23000, 8823],
    [24000, 9027],
    [25000, 9129],
    [26000, 9333],
    [27000, 9538],
    [28000, 9738],
    [29000, 9942],
    [30000, 10144],
    [31000, 10349],
    [32000, 10551],
    [33000, 10753],
    [34000, 10957],
    [35000, 11160],
    [36000, 11364],
    [37000, 11566],
    [38000, 11770],
    [39000, 11972],
    [40000, 12175],
    [41000, 12277],
    [42000, 12683],
    [43000, 12885],
    [44000, 13090],
    [45000, 13200],
    [46000, 13430],
    [47000, 13749],
    [48000, 13860],
    [49000, 14079],
    [50000, 14298],
    [51000, 14520],
    [52000, 14739],
    [53000, 14960],
    [54000, 15179],
    [55000, 15399],
    [56000, 15620],
    [57000, 15950],
    [58000, 16058],
    [59000, 16279],
    [60000, 16509],
    [61000, 16720],
    [62000, 16939],
    [63000, 17159],
    [64000, 17380],
    [65000, 17599],
    [66000, 17829],
    [67000, 18150],
    [68000, 18259],
    [69000, 18480],
    [70000, 18699],
    [71000, 21210],
    [72000, 21687],
    [73000, 22144],
    [74000, 22406],
    [75000, 22668],
    [76000, 22964],
    [77000, 23259],
    [78000, 23624],
    [79000, 23889],
    [80000, 24284],
    [81000, 24450],
    [82000, 24695],
    [83000, 24940],
    [84000, 25185],
    [85000, 25431],
    [86000, 25554],
    [87000, 25799],
    [88000, 26043],
    [89000, 26168],
    [90000, 26412],
    [91000, 26780],
    [92000, 27127],
    [93000, 27251],
    [94000, 27331],
    [95000, 27637],
    [96000, 27841],
    [97000, 28046],
    [98000, 28248],
    [99000, 28448],
    [100000, 28854],
    [101000, 29056],
    [102000, 29259],
    [103000, 29363],
    [104000, 29665],
    [105000, 29862],
    [106000, 30274],
    [108000, 30680],
    [110000, 31087],
    [112000, 31493],
    [114000, 31900],
    [116000, 32119],
    [118000, 32559],
    [120000, 33000],
    [122000, 33440],
    [124000, 33879],
    [126000, 34319],
    [128000, 34760],
    [130000, 35200],
    [132000, 35639],
    [134000, 36079],
    [136000, 36519],
    [138000, 36960],
    [Infinity, 37179],
  ];

  function trackClarity(eventName) {
    if (typeof window.clarity !== 'function') return;
    try { window.clarity('event', eventName); } catch (e) {}
  }

  function lookupRate(table, weightGrams) {
    for (const [maxG, rate] of table) {
      if (weightGrams <= maxG) return rate;
    }
    return table[table.length - 1][1];
  }

  // Format a cents/pence value as a currency string
  function fmtMoney(minor, symbol) {
    if (minor === 0) return 'Free';
    return `${symbol}${(minor / 100).toFixed(2)}`;
  }

  // Format an amount in the cart's own currency (the total, Route) the way the
  // store does, so it matches the Liquid-rendered rows above it: the EU store's
  // format is €{{amount_with_comma_separator}}, which toFixed would print as
  // "€138.90" under a subtotal of "€172,90".
  function fmtCartMoney(minor, symbol) {
    const format = window.theme?.settings?.money_with_currency_format;
    if (format && typeof window.formatMoney === 'function') return window.formatMoney(minor, format);
    return fmtMoney(minor, symbol);
  }

  class SidecartV2 extends HTMLElement {

    connectedCallback() {
      this.currentZone = this.dataset.zone || 'UK';
      this._routeMinor = 0;
      this._setupEvents();
      this._initZone();
      this._initCarousel();
      this._watchRouteWidget();
      this._boundResize = () => this._onResizeFixRoute();
      window.addEventListener('resize', this._boundResize);
    }

    disconnectedCallback() {
      if (this._boundResize) window.removeEventListener('resize', this._boundResize);
      if (this._routeObs) this._routeObs.disconnect();
    }

    _setupEvents() {
      // Flag <body> while the drawer is open so CSS can hide the chat widget
      if (!this._cartOpenObs) {
        this._cartOpenObs = new MutationObserver(() => {
          document.body.classList.toggle('sc2-cart-open', this.classList.contains('active'));
        });
        this._cartOpenObs.observe(this, { attributes: true, attributeFilter: ['class'] });
      }

      // Cart toggle button
      document.getElementById('cart-drawer-toggle')
        ?.addEventListener('click', e => { e.preventDefault(); this.open(); });

      // cart:refresh event (from external sources like wishlist apps)
      document.addEventListener('cart:refresh', () => this.refresh());

      // Debounced qty input changes (direct typing)
      this._debouncedChange = debounce(e => {
        if (e.target.classList.contains('qty')) {
          const key = e.target.dataset.key;
          const qty = parseInt(e.target.value, 10);
          if (key && !isNaN(qty) && qty >= 0) this.updateQuantity(key, qty);
        }
      }, 400);
      this.addEventListener('change', this._debouncedChange);

      // Editing the code clears the "didn't apply" message
      this.addEventListener('input', e => {
        if (e.target.closest && e.target.closest('.sc2-discount-input')) this._clearDiscountMessage();
      });

      // Delegated click handler
      this.addEventListener('click', e => {
        const minus = e.target.closest('[data-sc2-minus]');
        if (minus) { this._stepQty(minus.dataset.sc2Minus, -1); return; }

        const plus = e.target.closest('[data-sc2-plus]');
        if (plus) { this._stepQty(plus.dataset.sc2Plus, 1); return; }

        const remove = e.target.closest('[data-sc2-remove]');
        if (remove) { this.updateQuantity(remove.dataset.sc2Remove, 0); return; }

        const zoneBtn = e.target.closest('[data-sc2-zone]');
        if (zoneBtn) { this._selectZone(zoneBtn.dataset.sc2Zone); return; }

        const zoneToggle = e.target.closest('.sc2-zone-toggle');
        if (zoneToggle) { this._toggleZonePicker(); return; }

        const removeDiscount = e.target.closest('.sc2-discount-remove');
        if (removeDiscount) { this._removeDiscount(removeDiscount); return; }

        const applyDiscount = e.target.closest('.sc2-discount-apply');
        if (applyDiscount) { this._applyDiscount(); return; }

        const addUpsell = e.target.closest('[data-sc2-add]');
        if (addUpsell) { this._addUpsell(addUpsell); return; }

        // Carousel arrows live in this one delegated handler (CA-11): wiring
        // them in _initCarousel added another listener on every drawer open,
        // so one click jumped as many cards as the drawer had been opened.
        if (e.target.closest('.sc2-upsells-prev')) { this._scrollCarousel(-1); return; }
        if (e.target.closest('.sc2-upsells-next')) { this._scrollCarousel(1); return; }

      });
    }

    open() {
      OverlayManager.open(this);
      dispatchCustomEvent('cart-drawer:open');
      this._syncDataFromDOM();
      this._selectZone(this.currentZone);
      this._initCarousel();
      this._watchRouteWidget();
    }

    _stepQty(key, delta) {
      const input = this.querySelector(`.qty[data-key="${CSS.escape(key)}"]`);
      if (!input) return;
      const newVal = Math.max(0, parseInt(input.value, 10) + delta);
      input.value = newVal;
      this.updateQuantity(key, newVal);
    }

    // Shopify gives a line a new key whenever its quantity changes (verified
    // on this store: 52 → 3 → 4 gave three keys), so after a change the key
    // the drawer was drawn with may be gone. The variant part before the colon
    // stays; fall back to it when exactly one line has that variant.
    _lineEl(key) {
      const exact = this.querySelector(`.sc2-line[data-sc2-key="${CSS.escape(key)}"]`);
      if (exact) return exact;
      const variant = String(key).split(':')[0];
      const same = this.querySelectorAll(`.sc2-line[data-sc2-key^="${CSS.escape(variant + ':')}"]`);
      return same.length === 1 ? same[0] : null;
    }

    // The current key for a line the drawer knew by an older one: the one
    // line with the same variant AND the same properties (gift tag, accessory
    // tags), so a gift removed in the background can never hand its tap on to
    // a bought line of the same product. null when there isn't exactly one.
    _currentKey(key, drawnProps) {
      const variant = String(key).split(':')[0];
      const drawn = this.querySelector(`.sc2-line[data-sc2-key="${CSS.escape(key)}"]`);
      const raw = drawnProps !== undefined ? drawnProps : drawn?.dataset.sc2Props;
      const props = raw !== undefined ? this._propsSignature(raw) : null;
      if (props === null) return Promise.resolve(null);
      return fetch(`${theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
        .then(r => r.json())
        .then(cart => {
          const same = (cart.items || []).filter(item =>
            String(item.key).split(':')[0] === variant &&
            this._propsSignature(item.properties) === props);
          return same.length === 1 && same[0].key !== key ? same[0].key : null;
        })
        .catch(() => null);
    }

    _propsSignature(props) {
      try {
        const obj = typeof props === 'string' ? JSON.parse(props || '{}') : (props || {});
        return JSON.stringify(Object.keys(obj || {}).sort().map(k => [k, obj[k]]));
      } catch (e) {
        return null;
      }
    }

    getSectionsToRender() {
      return [
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML || '';
    }

    _syncDataFromDOM() {
      // After section re-renders, read updated shipping/cart data from the embedded .sc2-data span
      const data = this.querySelector('.sc2-data');
      if (!data) return;
      this.dataset.estUk  = data.dataset.estUk  || '0';
      this.dataset.estNi  = data.dataset.estNi  || '0';
      this.dataset.estEu  = data.dataset.estEu  || '0';
      this.dataset.estUs  = data.dataset.estUs  || '0';
      this.dataset.cartTotal = data.dataset.cartTotal || '0';
    }

    _afterRender() {
      this._syncDataFromDOM();
      this._selectZone(this.currentZone);
      this._initCarousel();
      this._watchRouteWidget();
      this._paintLineErrors();
    }

    // Lines are addressed by key, not position (CA-07): gift-promo.js adds and
    // removes gifts in the background, Shopify puts new lines at the top, and
    // a position read from a drawer drawn a moment earlier can point at the
    // line above the one the shopper tapped.
    // Changes go to Shopify one at a time. Two quick taps on + sent two
    // requests at once and Shopify could apply them in either order (tap 1 →
    // 2, tap 2 → 3, cart ended on 2). Queued, the second waits for the first;
    // its key is stale by then, so the line's properties are noted at the tap
    // for _currentKey to find it again.
    updateQuantity(key, quantity) {
      const props = this._lineEl(key)?.dataset.sc2Props;
      const send = () => this._sendQuantity(key, quantity, false, props);
      this._qtyQueue = (this._qtyQueue || Promise.resolve()).then(send, send);
      return this._qtyQueue;
    }

    _sendQuantity(key, quantity, retried, props) {
      this._lineErrors = {};
      this.querySelectorAll('.sc2-line-error').forEach(el => el.remove());
      const lineEl = this._lineEl(key);
      if (lineEl) lineEl.classList.add('sc2-loading');

      const body = JSON.stringify({
        id: key,
        quantity,
        sections: this.getSectionsToRender().map(s => s.section),
        sections_url: window.location.pathname,
      });

      dispatchCustomEvent('line-item:change:start', { quantity });

      return fetch(theme.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body,
      })
        .then(r => r.json().then(state => ({ status: r.status, state })))
        .then(({ status, state }) => {
          // 400 "no valid id or line parameter": the key went stale (a quick
          // second tap, or a change elsewhere). Retry once with the line's
          // current key rather than giving up or guessing by position.
          if (status === 400 && !retried) {
            return this._currentKey(key, props).then(current => {
              if (current) return this._sendQuantity(current, quantity, true, props);
              this._showLineError(key, null);
            });
          }
          // A refused change (422, e.g. more than are in stock) comes back as
          // an error body, not a cart, and Shopify may still have applied part
          // of it ("Only 52 items were added…"). Redraw from the real cart —
          // cart:refresh also has gift-promo.js re-check the gifts — then say
          // why, rather than leaving the line faded and unclickable (CA-08).
          if (state.errors || state.status || !state.sections) {
            // /cart/change answers {errors: "…"}; the .js route answers
            // {status, message, description}.
            const reason = typeof state.errors === 'string' ? state.errors : (state.description || state.message);
            this._showLineError(key, reason || 'Sorry, that quantity isn\'t available.');
            return;
          }
          this.getSectionsToRender().forEach(section => {
            const el = document.getElementById(section.id);
            if (!el) return;
            const target = el.querySelector(section.selector) || el;
            if (state.sections?.[section.section]) {
              target.innerHTML = this.getSectionInnerHTML(state.sections[section.section], section.selector);
            }
          });
          dispatchCustomEvent('line-item:change:end', { quantity, cart: state });
          this._afterRender();
        })
        .catch(err => {
          console.error('sidecart-v2 updateQuantity error', err);
          this._showLineError(key, 'Sorry, that didn\'t update. Please try again.');
        });
    }

    // The message is kept until the shopper's next change and put back after
    // every redraw: cart:refresh redraws the drawer, and gift-promo.js's own
    // re-check can redraw it again a moment later.
    _showLineError(key, message) {
      this._lineErrors = { [key]: message };
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      // Never leave the line frozen, even if the redraw itself fails.
      setTimeout(() => this._lineEl(key)?.classList.remove('sc2-loading'), 8000);
    }

    _paintLineErrors() {
      Object.entries(this._lineErrors || {}).forEach(([key, message]) => {
        const lineEl = this._lineEl(key);
        if (!lineEl || !message || lineEl.querySelector('.sc2-line-error')) return;
        const note = document.createElement('p');
        note.className = 'sc2-line-error';
        note.setAttribute('role', 'alert');
        note.textContent = message;
        (lineEl.querySelector('.sc2-line-controls') || lineEl).after(note);
      });
    }

    refresh() {
      return fetch(`${window.location.pathname}?sections=cart-drawer,cart-bubble`)
        .then(r => r.json())
        .then(state => {
          this.getSectionsToRender().forEach(section => {
            const el = document.getElementById(section.id);
            if (!el) return;
            const target = el.querySelector(section.selector) || el;
            if (state[section.section]) {
              target.innerHTML = this.getSectionInnerHTML(state[section.section], section.selector);
            }
          });
          this._afterRender();
        });
    }

    // ── Zone ──────────────────────────────────────────────

    _initZone() {
      this._syncDataFromDOM();
      this._selectZone(this.currentZone);
    }

    _toggleZonePicker() {
      const picker = this.querySelector('.sc2-zone-picker');
      if (picker) picker.hidden = !picker.hidden;
    }

    _selectZone(code) {
      this.currentZone = code;

      const zones = {
        UK:  { label: 'United Kingdom',   symbol: '£', eta: '2–3 days', attr: 'estUk' },
        NI:  { label: 'Northern Ireland', symbol: '£', eta: '3–5 days', attr: 'estNi' },
        EU:  { label: 'Europe',           symbol: '€', eta: '5–7 days', attr: 'estEu' },
        US:  { label: 'United States',    symbol: '$', eta: '7–10 days', attr: 'estUs' },
      };

      const zone = zones[code];
      if (!zone) return;

      // Zone pill label
      const label = this.querySelector('.sc2-zone-label');
      if (label) label.textContent = zone.label;

      // Estimated shipping amount
      const estMinor = parseInt(this.dataset[zone.attr] || '0', 10);
      const estEl = this.querySelector('.sc2-est-shipping');
      if (estEl) {
        estEl.textContent = fmtMoney(estMinor, zone.symbol);
        estEl.classList.toggle('sc2-summary-amount--free', estMinor === 0);
      }

      // Update total (include Route protection if active)
      const cartTotal = parseInt(this.dataset.cartTotal || '0', 10);
      const totalEl = this.querySelector('.sc2-total-price');
      if (totalEl) {
        totalEl.textContent = fmtCartMoney(cartTotal + estMinor + (this._routeMinor || 0), zone.symbol);
      }

      // Zone button active states
      this.querySelectorAll('[data-sc2-zone]').forEach(btn => {
        btn.classList.toggle('sc2-zone-btn--active', btn.dataset.sc2Zone === code);
      });

      // Close picker
      const picker = this.querySelector('.sc2-zone-picker');
      if (picker) picker.hidden = true;
    }

    // ── Upsells ───────────────────────────────────────────

    _initCarousel() {
      // Cards are Liquid-rendered; just wire up navigation and dots
      const section = this.querySelector('.sc2-upsells');
      if (!section) return;

      this._carouselIdx = 0;
      this._carouselCount = section.querySelectorAll('.sc2-upsell-card').length;
      this._updateDots();
    }

    _scrollCarousel(dir) {
      const visibleCount = 2;
      const cardWidth = 210;
      const maxIdx = Math.max(0, this._carouselCount - visibleCount);
      this._carouselIdx = Math.max(0, Math.min(maxIdx, this._carouselIdx + dir));
      const track = this.querySelector('.sc2-upsells-track');
      if (track) track.style.transform = `translateX(-${this._carouselIdx * cardWidth}px)`;
      this._updateDots();
    }

    _updateDots() {
      const dotsEl = this.querySelector('.sc2-upsells-dots');
      if (!dotsEl) return;
      const visibleCount = 2;
      const maxIdx = Math.max(0, (this._carouselCount || 0) - visibleCount);
      dotsEl.innerHTML = Array.from({ length: maxIdx + 1 }, (_, i) =>
        `<span${i === this._carouselIdx ? ' class="active"' : ''}></span>`
      ).join('');
    }

    _addUpsell(btn) {
      btn.disabled = true;
      btn.textContent = '…';

      const productTitle = btn.dataset.sc2ProductTitle || '';
      const productHandle = btn.dataset.sc2ProductHandle || '';
      const parentHandle = btn.dataset.sc2Parent || '';

      fetch(`${theme.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: btn.dataset.sc2Add,
          quantity: 1,
          properties: {
            '_sc2_source': 'sidecart-upsell',
            '_sc2_product': productHandle,
            '_sc2_parent': parentHandle,
          },
        }),
      })
        .then(r => r.json().then(response => ({ ok: r.ok, response })))
        .then(({ ok, response }) => {
          // A refused add (sold out since the drawer was drawn, stock limit)
          // answers 422 with an error body: it used to show "Added ✓", log a
          // Clarity add and fire cart:item-added anyway (CA-09).
          if (!ok || response.status) {
            btn.textContent = /sold out|out of stock|not available|available/i.test(response.description || response.message || '') ? 'Sold out' : 'Unavailable';
            btn.title = response.description || response.message || '';
            this.refresh();
            return;
          }
          trackClarity('sidecart_upsell_added');
          btn.textContent = 'Added ✓';
          btn.classList.add('sc2-upsell-add--added');
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
          this.refresh();
        })
        .catch(() => {
          btn.disabled = false;
          btn.textContent = 'Add';
        });
    }

    // ── Discount ──────────────────────────────────────────

    _applyDiscount() {
      const input = this.querySelector('.sc2-discount-input');
      const applyBtn = this.querySelector('.sc2-discount-apply');
      if (!input || !input.value.trim()) return;

      const code = input.value.trim();
      const prevDiscountCount = this.querySelectorAll('.sc2-summary-row--discount').length;

      if (applyBtn) {
        applyBtn.textContent = 'Applying...';
        applyBtn.disabled = true;
      }

      fetch(`/discount/${encodeURIComponent(code)}`)
        .then(() => this.refresh())
        .then(() => {
          // CA-10: a code changes what the cart earns, but the drawer redraws
          // itself here without cart:refresh, so gift-promo.js never
          // re-checked the gifts. Ask it directly (cart:refresh would redraw
          // the drawer a second time).
          window.GiftPromo?.refresh?.();
          const newDiscountCount = this.querySelectorAll('.sc2-summary-row--discount').length;
          const newInput = this.querySelector('.sc2-discount-input');
          const newBtn = this.querySelector('.sc2-discount-apply');

          if (newDiscountCount > prevDiscountCount) {
            this._discountCode = code;
            const form = this.querySelector('.sc2-checkout-form');
            if (form) form.action = `/checkout?discount=${encodeURIComponent(code)}`;
            if (newInput) newInput.value = code;
            if (newBtn) { newBtn.textContent = '✓ Applied'; newBtn.disabled = true; }
          } else {
            // The old 2.5 s "Invalid code" label on the button was easy to
            // miss. Keep a message under the field until the shopper edits it.
            if (newInput) newInput.value = code;
            if (newBtn) { newBtn.textContent = 'Apply'; newBtn.disabled = false; }
            this._setDiscountMessage(
              "This code didn't apply to your basket. Check the spelling and any conditions, such as minimum spend or eligible products."
            );
          }
        })
        .catch(() => {
          if (applyBtn) { applyBtn.textContent = 'Apply'; applyBtn.disabled = false; }
          this._setDiscountMessage("We couldn't check that code. Please try again.");
        });
    }

    // Remove one discount code. /cart/update.js takes the full list of codes the
    // cart should end up with, so send every shown code except this one.
    _removeDiscount(btn) {
      const code = btn.dataset.sc2RemoveDiscount;
      if (!code || btn.disabled) return;
      const keep = [...this.querySelectorAll('[data-sc2-remove-discount]')]
        .map(b => b.dataset.sc2RemoveDiscount)
        .filter(c => c && c.toLowerCase() !== code.toLowerCase());

      btn.disabled = true;
      this._clearDiscountMessage();

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: keep.join(',') })
      })
        .then(res => { if (!res.ok) throw new Error('discount update failed'); })
        .then(() => this.refresh())
        .then(() => {
          // /discount/CODE also stores the code in a cookie that checkout
          // re-applies, so clear it or the removed code comes back there.
          const host = location.hostname;
          ['', `; domain=${host}`, `; domain=.${host.replace(/^www\./, '')}`].forEach(d => {
            document.cookie = `discount_code=; Max-Age=0; path=/${d}`;
          });
          // Removing a code can change what the cart earns (see CA-10)
          window.GiftPromo?.refresh?.();
          this._discountCode = null;
        })
        .catch(() => {
          btn.disabled = false;
          this._setDiscountMessage("We couldn't remove that code. Please try again.");
        });
    }

    _setDiscountMessage(text) {
      const row = this.querySelector('.sc2-discount-row');
      if (!row) return;
      let msg = this.querySelector('.sc2-discount-msg');
      if (!msg) {
        msg = document.createElement('div');
        msg.className = 'sc2-discount-msg';
        msg.setAttribute('role', 'alert');
        row.insertAdjacentElement('afterend', msg);
      }
      msg.textContent = text;
      const input = row.querySelector('.sc2-discount-input');
      if (input) { input.classList.add('is-invalid'); input.setAttribute('aria-invalid', 'true'); }
    }

    _clearDiscountMessage() {
      const msg = this.querySelector('.sc2-discount-msg');
      if (msg) msg.remove();
      const input = this.querySelector('.sc2-discount-input');
      if (input) { input.classList.remove('is-invalid'); input.removeAttribute('aria-invalid'); }
    }

    // ── Route Protection price sync ──────────────────────────

    _watchRouteWidget() {
      if (this._routeObs) this._routeObs.disconnect();
      const cta = this.querySelector('.cart-drawer-buttons');
      if (!cta) return;
      this._routeObs = new MutationObserver(() => {
        this._fixRouteLayout();
        this._syncRoutePrice();
      });
      // Scope observer to .cart-drawer-buttons only to avoid an infinite
      // mutation loop with _selectZone / _syncRoutePrice elsewhere in the
      // sidecart. _fixRouteLayout still searches the whole sidecart.
      this._routeObs.observe(cta, { childList: true, subtree: true, characterData: true });
      // Re-check a few times after open in case Route injects outside the
      // CTA row (mobile) and never triggers a mutation inside it.
      this._fixRouteLayout();
      this._syncRoutePrice();
      if (this._routePoll) clearTimeout(this._routePoll);
      [120, 400, 900, 1800].forEach(ms => setTimeout(() => this._fixRouteLayout(), ms));
    }

    // Route injects [data-route-widget-header] and [data-route-widget-cwc] inside the
    // <form> element. For the CSS grid to span them full-width they must be direct
    // children of .cart-drawer-buttons. Move them out once Route has injected them.
    _fixRouteLayout() {
      const cta = this.querySelector('.cart-drawer-buttons');
      if (!cta) return;
      // Search the WHOLE sidecart — Route may inject these as siblings
      // of .cart-drawer-buttons (e.g. on mobile) rather than children.
      const header = this.querySelector('[data-route-widget-header]');
      const cwc    = this.querySelector('[data-route-widget-cwc]');
      const cloned = this.querySelector('[data-route-cloned-button]');
      const form   = cta.querySelector('.sc2-checkout-form');

      // Toggle the marker class so CSS grid kicks in on any Route presence
      const routePresent = !!(header || cwc || cloned);
      cta.classList.toggle('sc2-has-route', routePresent);

      if (header && header.parentElement !== cta) {
        cta.insertBefore(header, cta.firstChild);
      }
      if (cwc && cwc.parentElement !== cta) {
        cta.appendChild(cwc);
      }

      // Force full widths inline. This bypasses any CSS Route ships (which sets
      // min-width / inline styles on its cloned button and shrinks the row).
      if (routePresent) {
        // Force .cart-drawer-buttons itself to full width — Route's CSS
        // shrinks it to ~270px on mobile.
        cta.style.setProperty('width', '100%', 'important');
        cta.style.setProperty('max-width', '100%', 'important');
        cta.style.setProperty('margin-left', '0', 'important');
        cta.style.setProperty('margin-right', '0', 'important');
        cta.style.setProperty('grid-template-columns', 'minmax(0, 1fr)', 'important');

        if (form) {
          form.style.setProperty('width', '100%', 'important');
          form.style.setProperty('max-width', '100%', 'important');
          form.style.setProperty('min-width', '0', 'important');
          form.style.setProperty('flex', 'none', 'important');
          form.style.setProperty('display', 'flex', 'important');
          form.style.setProperty('height', '42px', 'important');
          form.style.setProperty('box-sizing', 'border-box', 'important');
          form.style.setProperty('margin', '0', 'important');
        }
        const checkoutBtns = cta.querySelectorAll(
          '[data-route-cloned-button], .sc2-checkout-form button[name="checkout"]'
        );
        checkoutBtns.forEach(b => {
          b.style.setProperty('width', '100%', 'important');
          b.style.setProperty('max-width', '100%', 'important');
          b.style.setProperty('min-width', '0', 'important');
          b.style.setProperty('flex', '1 1 0', 'important');
          b.style.setProperty('height', '42px', 'important');
          b.style.setProperty('margin', '0', 'important');
          b.style.setProperty('box-sizing', 'border-box', 'important');
        });
      }
    }

    _onResizeFixRoute() {
      if (this._resizeFixTimer) clearTimeout(this._resizeFixTimer);
      this._resizeFixTimer = setTimeout(() => this._fixRouteLayout(), 100);
    }

    _syncRoutePrice() {
      const header = this.querySelector('[data-route-widget-header]');
      let minor = 0;
      if (header) {
        const match = header.textContent.match(/[\d]+[.,]\d{2}/);
        if (match) minor = Math.round(parseFloat(match[0].replace(',', '.')) * 100);
      }
      this._routeMinor = minor;

      let row = this.querySelector('.sc2-summary-row--route');
      const summary = this.querySelector('.sc2-summary');
      if (minor > 0) {
        const zones = { UK: '£', NI: '£', EU: '€', US: '$' };
        const sym = zones[this.currentZone] || '£';
        if (!row && summary) {
          const totalRow = summary.querySelector('.sc2-summary-row--total');
          row = document.createElement('div');
          row.className = 'sc2-summary-row sc2-summary-row--route';
          row.innerHTML = `<span>Route Shipping Protection</span><span class="sc2-summary-amount"></span>`;
          summary.insertBefore(row, totalRow);
        }
        if (row) row.querySelector('.sc2-summary-amount').textContent = fmtCartMoney(minor, sym);
      } else if (row) {
        row.remove();
      }

      this._selectZone(this.currentZone);
    }

  }

  customElements.define('sidecart-v2', SidecartV2);
}